// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web  —  src/features/estoque/services/movimentacaoService.ts
// ════════════════════════════════════════════════════════════════════════════

import { apiClient } from '@/lib/apiClient';
import type {
  MovimentacaoResumo,
  MovimentacaoDetalhe,
  CriarMovimentacaoRequest,
  PaginadoResponse,
} from '../types';

const BASE = '/api/movimentacoes-estoque';

/** Filtros da lista (servidor). Período = dia do movimento, yyyy-MM-dd. */
export interface FiltrosMovimentacao {
  busca?: string;
  dtInicio?: string;
  dtFim?: string;
  ordenarPor?: 'data' | 'id' | 'valor';
  decrescente?: boolean;
}

export const movimentacaoService = {
  async getAll(
    pagina = 1,
    tamanhoPagina = 20,
    tipoId = 0,
    filtros: FiltrosMovimentacao = {},
  ): Promise<PaginadoResponse<MovimentacaoResumo>> {
    const { data } = await apiClient.get<PaginadoResponse<MovimentacaoResumo>>(BASE, {
      params: {
        pagina, tamanhoPagina, tipoId: tipoId > 0 ? tipoId : undefined,
        busca: filtros.busca?.trim() || undefined,
        dtInicio: filtros.dtInicio || undefined,
        dtFim: filtros.dtFim || undefined,
        ordenarPor: filtros.ordenarPor,
        decrescente: filtros.decrescente,
      },
    });
    return data;
  },

  async getById(id: number): Promise<MovimentacaoDetalhe> {
    const { data } = await apiClient.get<MovimentacaoDetalhe>(`${BASE}/${id}`);
    return data;
  },

  async getTipos(): Promise<{ id: number; descricao: string }[]> {
    const { data } = await apiClient.get<{ id: number; descricao: string }[]>(`${BASE}/tipos`);
    return data;
  },

  async create(req: CriarMovimentacaoRequest): Promise<MovimentacaoResumo> {
    const { data } = await apiClient.post<MovimentacaoResumo>(BASE, req);
    return data;
  },

  async delete(id: number): Promise<void> {
    await apiClient.delete(`${BASE}/${id}`);
  },
};
